document.addEventListener("DOMContentLoaded", function () {
  var iframe = document.getElementById("3d");
  var categoryList = document.querySelector(".category-list");
  var leftArrow = document.querySelector(".category-slide-left");
  var rightArrow = document.querySelector(".category-slide-right");

  initKenissi();

  if (categoryList.scrollLeft !== 0) {
    categoryList.scrollLeft = 0;
  }

  // Function to check the scroll position and toggle the disable state of arrows
  function checkArrows() {
    var scrollLeft = categoryList.scrollLeft;
    var maxScrollLeft = categoryList.scrollWidth - categoryList.clientWidth;

    leftArrow.disabled = scrollLeft === 0;
    rightArrow.disabled = scrollLeft >= maxScrollLeft;
  }

  function initKenissi() {
    document
      .querySelectorAll(".watch-part__variant-button.skeleton")
      .forEach(function (button) {
        button.classList.add("hidden");
      });
  }

  if (categoryList && leftArrow && rightArrow) {
    if ($(window).width() < 767) {
      leftArrow.addEventListener("click", () => {
        var prevEle = $(`.category-item.selected`).prev();
        var prevTarget = prevEle.width() + 20;
        $(`.category-item`).removeClass(`selected`);
        $(prevEle).addClass(`selected`).trigger("click");
        categoryList.scrollBy({
          left: `-${prevTarget}`, // Adjust the value to control how far it scrolls
          behavior: "smooth",
        });
      });

      rightArrow.addEventListener("click", () => {
        var nextEle = $(`.category-item.selected`).next();
        var nextTarget = nextEle.width() + 20;
        $(`.category-item`).removeClass(`selected`);
        $(nextEle).addClass(`selected`).trigger("click");
        console.log("nextTarget", nextTarget);
        categoryList.scrollBy({
          left: nextTarget, // Adjust the value to control how far it scrolls
          behavior: "smooth",
        });
      });
    } else {
      leftArrow.addEventListener("click", () => {
        categoryList.scrollBy({
          left: -200, // Adjust the value to control how far it scrolls
          behavior: "smooth",
        });
      });

      rightArrow.addEventListener("click", () => {
        categoryList.scrollBy({
          left: 200, // Adjust the value to control how far it scrolls
          behavior: "smooth",
        });
      });
    }

    // Initial check for arrow state
    checkArrows();
  }

  // This function will be used to scroll the category list left or right
  function scrollCategoryList(direction) {
    const categoryList = document.querySelector(".category-list");
    const selectedItem = document.querySelector(".category-item.selected");
    if (selectedItem) {
      // Get the distance to scroll based on the width of the category list and selected item
      const scrollDistance =
        selectedItem.getBoundingClientRect().width *
        (direction === "right" ? 1 : -1);
      categoryList.scrollBy({ left: scrollDistance, behavior: "smooth" });
    }
  }

  const categoryItems = document.querySelectorAll(".category-item");
  const productCategories = document.querySelectorAll(".product-category");
  let currentCategoryIndex = 0;

  function navigateToCategory(index) {
    hideAllCategories();
    if (index >= 0 && index < productCategories.length) {
      currentCategoryIndex = index;
      const handle = productCategories[index].getAttribute(
        "data-product-handle"
      );
      showCategory(handle);
      updateSelectedCategoryItem(index);

      // Send the message to change the camera angle based on the current category
      sendCameraChangeMessage(index);
    }
  }

  function hideAllCategories() {
    productCategories.forEach((category) => {
      category.style.display = "none";
    });
  }

  function showCategory(handle) {
    const categoryToShow = document.querySelector(
      `.product-category[data-product-handle="${handle}"]`
    );
    if (categoryToShow) {
      categoryToShow.style.display = "block";
    }
  }

  function sendCameraChangeMessage(index) {
    let cameraIndex;
    // Map the category index to a camera index
    switch (index) {
      case 0:
        cameraIndex = 5; // Front facing camera
        break;
      case 7:
        cameraIndex = 1; // Backplate facing camera
        break;
      case 1:
        cameraIndex = 5; // Front facing camera
        break;
      case 2:
        cameraIndex = 6; // Shock absorber camera
        break;
      case 3:
        cameraIndex = 3; // Dial camera
        break;
      case 4:
        cameraIndex = 3; // Dial camera
        break;
      case 5:
        cameraIndex = 1; // Backplate facing camera
        break;
      case 6:
        cameraIndex = 1; // Backplate facing camera
        break;
      case 8:
        cameraIndex = 0; // Engraving plate camera
        break;
      case 9:
        cameraIndex = 4; // Strap camera
        break;
      case 10:
        cameraIndex = 2; // Buckle camera
        break;
      default:
        cameraIndex = 5; // Default or fallback camera index
    }

    // Send a message to the iframe with the "ChangeCamera" event and the mapped camera index
    if (iframe) {
      iframe.contentWindow.postMessage(
        { type: "CameraChange", index: cameraIndex },
        "*"
      );
      console.log("Requested to change camera to index:", cameraIndex);
    }
  }

  function updateSelectedCategoryItem(index) {
    categoryItems.forEach((item, idx) => {
      if (idx === index) {
        item.classList.add("selected");
      } else {
        item.classList.remove("selected");
      }
    });
  }

  // Attach click event to category items
  categoryItems.forEach((item, index) => {
    item.addEventListener("click", function () {
      navigateToCategory(index);
    });
  });

  // Initialize button functionalities for each category
  productCategories.forEach((category, index) => {
    const prevButton = category.querySelector("#prevCategory");
    const nextButton = category.querySelector("#nextCategory");
    const finishButton = category.querySelector("#finishConfig");

    if (prevButton) {
      prevButton.addEventListener("click", function () {
        scrollCategoryList("left");
        navigateToCategory(index - 1);
        if (prevButton.classList.contains("finalPrice")) {
          // Call the function here
          exitFinalPrice();
        }
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", function () {
        scrollCategoryList("right");
        navigateToCategory(index + 1);
      });
    }

    if (finishButton) {
      finishButton.addEventListener("click", function () {
        // Send a message to the iframe to finish the configuration
        iframe.contentWindow.postMessage({ type: "finishConfiguration" }, "*");
        iframe.contentWindow.postMessage(
          { type: "CameraChange", index: 5 },
          "*"
        );
        console.log("Requested to finish configuration");
      });
    }
  });

  // Initially show the first category
  navigateToCategory(0);

  function postSKUdetails(selectedButton) {
    const sku = selectedButton.dataset.variantSku;
    const details = { type: "SKU_details", sku };

    // Include text engraving if applicable
    if (selectedButton.classList.contains("showText")) {
      const textInput = selectedButton
        .closest(".product-category")
        .querySelector(".engraving-input input");
      if (textInput) {
        details.engravingText = textInput.value;
      }
    }

    // Include image file name if applicable
    if (selectedButton.classList.contains("showImage")) {
      const imageInput = selectedButton
        .closest(".product-category")
        .querySelector(".image-input input");
      if (imageInput && imageInput.files.length > 0) {
        details.printImage = imageInput.files[0].name; // Note: Only the file name is sent for reference
      }
    }

    // Post message to iframe with collected details
    iframe.contentWindow.postMessage(details, "*");
    console.log("Posted SKU_details message to iframe:", details);
  }

  function selectVariant(element) {
    // Extract the variant ID from the button's class list
    const variantId = [...element.classList]
      .find((cls) => cls.startsWith("variant-"))
      .split("-")[1];

    var parentCategory = element.closest(".product-category");

    // Hide all variant descriptions
    parentCategory
      .querySelectorAll(".variant-description")
      .forEach(function (description) {
        description.classList.add("hidden");
      });

    parentCategory
      .querySelectorAll(".disclaimer")
      .forEach(function (disclaimer) {
        disclaimer.classList.add("hidden");
      });

    // Remove 'selected' class from all variant buttons
    parentCategory
      .querySelectorAll(".watch-part__variant-button")
      .forEach(function (button) {
        button.classList.remove("selected");
      });

    // Add 'selected' class to the clicked variant button
    element.classList.add("selected");

    // Show the corresponding variant description using the variant ID
    var variantDescription = parentCategory.querySelector(
      ".variant-description#description-" + variantId
    );
    if (variantDescription) {
      variantDescription.classList.remove("hidden");
    }

    var disclaimer = parentCategory.querySelector(
      ".disclaimer#disclaimerID-" + variantId
    );
    if (disclaimer) {
      disclaimer.classList.remove("hidden");
    }

    // Conditionally hide skeleton or kenissi buttons based on the selected button class
    // Note: Searching across the entire document now
    if (element.classList.contains("skeletonSelected")) {
      document
        .querySelectorAll(".watch-part__variant-button.kenissi")
        .forEach(function (button) {
          button.classList.add("hidden");
        });
      document
        .querySelectorAll(".watch-part__variant-button.skeleton")
        .forEach(function (button) {
          button.classList.remove("hidden");
        });
    } else if (element.classList.contains("kenissiSelected")) {
      document
        .querySelectorAll(".watch-part__variant-button.skeleton")
        .forEach(function (button) {
          button.classList.add("hidden");
        });
      document
        .querySelectorAll(".watch-part__variant-button.kenissi")
        .forEach(function (button) {
          button.classList.remove("hidden");
        });
    }

    // Show or hide the engraving input based on the presence of 'showText' class
    var engravingInput = parentCategory.querySelector(".engraving-input");
    if (element.classList.contains("showText")) {
      engravingInput.classList.remove("hidden");
    } else {
      if (!engravingInput.classList.contains("hidden")) {
        engravingInput.classList.add("hidden");
      }
    }

    var imageInput = parentCategory.querySelector(".image-input");
    if (element.classList.contains("showImage")) {
      imageInput.classList.remove("hidden");
    } else {
      if (!imageInput.classList.contains("hidden")) {
        imageInput.classList.add("hidden");
      }
    }

    // Post SKU details to iframe
    postSKUdetails(element);

    var message = { type: "SKU", option: element.dataset.variantSku };
    iframe.contentWindow.postMessage(message, "*");
    console.log("SKU fired:", element.dataset.variantSku);
  }

  document
    .querySelectorAll(".watch-part__variant-button")
    .forEach(function (button) {
      button.addEventListener("click", function () {
        selectVariant(this);
      });
    });

  // Initialize sliding functionality for each slider container
  document
    .querySelectorAll(".slider-container")
    .forEach(function (sliderContainer, index) {
      console.log(
        "Initializing slider:",
        sliderContainer.id,
        "at index",
        index
      );
    });

  // Attach functionality to slide buttons
  document
    .querySelectorAll(".slide-left, .slide-right")
    .forEach(function (button) {
      button.addEventListener("click", function () {
        var targetSliderId = this.getAttribute("data-target");
        console.log("Button clicked, targeting slider:", targetSliderId);

        var targetSlider = document.getElementById(targetSliderId);
        if (!targetSlider) {
          console.error("Slider container not found for:", targetSliderId);
          return;
        }
        console.log("Target slider found:", targetSlider.id);

        var firstVisibleButton = targetSlider.querySelector(
          ".watch-part__variant-button:not(.hidden)"
        );
        var scrollAmount = firstVisibleButton
          ? firstVisibleButton.offsetWidth * 4
          : 0; // Scrolls by the width of four buttons
        console.log("Scroll amount:", scrollAmount);

        if (this.classList.contains("slide-left")) {
          targetSlider.scrollBy({
            left: -scrollAmount,
            top: 0,
            behavior: "smooth",
          });
          console.log("Sliding left:", -scrollAmount);
        } else {
          // slide-right
          targetSlider.scrollBy({
            left: scrollAmount,
            top: 0,
            behavior: "smooth",
          });
          console.log("Sliding right:", scrollAmount);
        }
      });
    });
  // Monitor the scroll event to toggle the arrow buttons' disabled state
  categoryList.addEventListener("scroll", checkArrows);
});

// Handling of Image and Text attributes for some variants.

document.addEventListener("DOMContentLoaded", function () {
  var iframe = document.getElementById("3d"); // Ensure this ID matches your iframe
  var fileReference = {}; // To hold references to files

  // Function to send message to iframe
  function sendMessageToIframe(skuDetails) {
    // Ensure the iframe contentWindow is available
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage(skuDetails, "*"); // '*' can be replaced with your target origin for security
      console.log("Sending message to iframe with:", skuDetails);
    }
  }

  // Function to handle input changes and prepare message for iframe
  function handleInputChange() {
    const productCategory = this.closest(".product-category");
    const selectedButton = productCategory.querySelector(
      ".watch-part__variant-button.selected"
    );
    const fontSelectionElement =
      productCategory.querySelector("#fontSelection");
    const font = fontSelectionElement ? fontSelectionElement.value : "";

    if (!selectedButton) return; // No action if no selected variant button

    const sku = selectedButton.dataset.variantSku;
    let details = { type: "SKU_details", sku: sku };

    // Add text engraving if applicable
    if (selectedButton.classList.contains("showText")) {
      const engravingInput = productCategory.querySelector(
        ".engraving-input input"
      );
      if (engravingInput) {
        details.engravingText = engravingInput.value;
      }
    }

    // Include image file name if applicable
    if (selectedButton.classList.contains("showImage")) {
      const imageInput = productCategory.querySelector(".image-input input");
      if (imageInput && imageInput.files.length > 0) {
        // Note: Due to browser security, the actual file path cannot be accessed
        details.printImage = imageInput.files[0].name;
        // Assuming you handle the file reference for later use
        fileReference[imageInput.files[0].name] = imageInput.files[0];
      }
    }

    details.font = font;

    // Send the data to the iframe
    sendMessageToIframe(details);
  }

  // Attach event listeners to inputs
  document
    .querySelectorAll(".engraving-input input, .image-input input")
    .forEach((input) => {
      input.addEventListener("change", handleInputChange);
    });

  // Attach event listener to font selection dropdown
  document
    .getElementById("fontSelection")
    .addEventListener("change", handleInputChange);

  // For text inputs, consider using 'input' event for live updates if needed
  document.querySelectorAll(".engraving-input input").forEach((input) => {
    input.addEventListener("input", handleInputChange);
  });
});

let globalConfig = [];
let totalPrice = 0;

window.addEventListener(
  "message",
  function (event) {
    // Replace 'https://your-iframe-origin.com' with the origin of your iframe content for security
    if (event.data.type === "configurationCompleted") {
      console.log("Received finished configuration:", event.data.watchConfig);
      totalPrice = 0; // Reset total price
      createFinalConfiguration(event.data.watchConfig).then((finalConfig) => {
        globalConfig = finalConfig;
        window.finalConfiguration = finalConfig;
        console.log("Window final config: ", window.finalConfiguration);
        updatePriceAndShowFinalPage();
      });
    }
  },
  false
);

async function createFinalConfiguration(receivedConfig) {
  const variantButtons = document.querySelectorAll(
    ".watch-part__variant-button"
  );
  const finalConfig = await Promise.all(
    receivedConfig.map(async (configItem) => {
      const sku = configItem.sku;
      let variantId = null;

      variantButtons.forEach((button) => {
        if (button.dataset.variantSku === sku) {
          variantId = button.dataset.variantId || null;
        }
      });

      if (!variantId) {
        console.warn("No variant found for SKU:", sku);
        return {
          ...configItem,
          variantId: null,
          variantName: null,
          variantImage: null,
        };
      }

      const variantDetails = await fetchVariantDetails(variantId);

      return {
        ...configItem,
        variantId: variantId,
        variantName: variantDetails.name,
        variantImage: variantDetails.featured_image
          ? variantDetails.featured_image.src
          : null,
      };
    })
  );

  console.log("Final Configuration with Variant Details:", finalConfig);
  return finalConfig;
}

// Function to fetch variant details and update total price
async function fetchVariantDetails(variantId) {
  // var d = new Date();
  // d.setTime(d.getTime() + (15 * 24 * 60 * 60 * 1000));
  // var expires = "expires=" + d.toUTCString();
  // document.cookie = "localization=" + Shopify.country + ";" + expires + ";path=/";
  // document.cookie = "cart_currency=" + Shopify.currency.active + ";" + expires + ";path=/";

  const response = await fetch(`/variants/${variantId}.js`);
  const variantData = await response.json();
  // Accumulate the total price
  totalPrice += variantData.price;
  return variantData;
}

// Assuming totalPrice is in cents
function formatCurrency(price) {
  // Convert price from cents to dollars
  let priceInDollars = price / 100;
  // Format the price as a string in the desired format
  let formattedPrice = priceInDollars.toFixed(2); // Example for USD, adjust according to your store's currency
  return formattedPrice;
}

// Update the display function
function updatePriceAndShowFinalPage() {
  const priceElement = document.getElementById("priceTotal");
  // const formattedPrice = formatCurrency(totalPrice);
  if (Shopify.currency.active == "JPY") {
    var formattedPrice = theme_custom.Shopify.formatMoney(
      totalPrice,
      $("#custom_currency").val()
    );
  } else if (Shopify.currency.active == "MYR") {
    var money_format = theme_custom.money_format.replace(" MYR", "");
    var formattedPrice = theme_custom.Shopify.formatMoney(
      totalPrice,
      money_format
    );
  } else {
    var formattedPrice = theme_custom.Shopify.formatMoney(
      totalPrice,
      theme_custom.money_format
    );
  }
  priceElement.textContent = formattedPrice;

  // Hide the configurator and show the final page
  document.getElementById("configurator").style.display = "none";
  document.getElementById("finalPage").style.display = "block";
  document.getElementById("categoryMenu").style.display = "none";
}

// Back from final page
function exitFinalPrice() {
  document.getElementById("configurator").style.display = "flex";
  document.getElementById("finalPage").style.display = "none";
  document.getElementById("categoryMenu").style.display = "flex";
}

document.addEventListener("DOMContentLoaded", function () {
  document
    .getElementById("addToBag")
    .addEventListener("click", async function () {
      // First clear the cart
      await clearCart();

      let cartItems = [];

      globalConfig.forEach((item) => {
        if (item.variantId) {
          let properties = {};
          if (item.properties && Object.keys(item.properties).length > 0) {
            for (const key in item.properties) {
              if (item.properties[key] !== "") {
                /* if (key === 'printImage' && fileReference[item.properties[key]]) {
                      // Append the file object directly
                      properties[key] = fileReference[item.properties[key]];
                  } else { */
                properties[key] = item.properties[key];
                /*}*/
              }
            }
          }
          cartItems.push({
            id: item.variantId,
            quantity: 1,
            properties: properties,
          });
        }
      });

      // Then add the new items
      await addItemsToCart(cartItems);
    });

  async function clearCart() {
    try {
      // Clear cart items
      let response = await fetch("/cart/clear.js", { method: "POST" });
      let data = await response.json();
      console.log("Cart cleared:", data);

      // Clear cart attributes explicitly
      response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            savedConfigCode: null, // Explicitly set to null to remove
          },
        }),
      });
      data = await response.json();
      console.log("Cart attributes cleared:", data);
    } catch (error) {
      console.error("Error clearing cart and attributes:", error);
    }
  }

  async function addItemsToCart(items) {
    const reversedItems = [...items].reverse();

    // Check if hexCode is present
    const cartProperties = window.hexCode
      ? { savedConfigCode: window.hexCode }
      : {};

    console.log("Adding cart properties: ", cartProperties);

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: reversedItems,
          attributes: cartProperties,
        }),
      });
      const data = await response.json();
      console.log("Items added to cart:", data);
      // Update cart count
      updateCartCount();
      window.location.href = "/cart";
    } catch (error) {
      console.error("Error adding items to cart:", error);
    }
  }

  /*
    async function addItemsToCart(items) {
      for (const item of items) {
          const formData = new FormData();
          formData.append('id', item.id);
          formData.append('quantity', item.quantity);
  
          // Add properties as individual entries
          for (const key in item.properties) {
              if (item.properties.hasOwnProperty(key)) {
                  if (key === 'printImage' && fileReferences[item.properties[key]]) {
                      // Append the file object directly
                      formData.append(key, fileReferences[item.properties[key]]);
                  } else {
                      formData.append(key, item.properties[key]);
                  }
              }
          }
          console.log(formData);
          // Post FormData for the current item
          try {
              const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  body: formData, // Notice we're sending FormData
                  // Headers are not set; the browser will set the Content-Type to 'multipart/form-data' automatically
              });
              const data = await response.json();
              console.log('Item added to cart:', data);
          } catch (error) {
              console.error('Error adding item to cart:', error);
          }
      }
      // After all items have been added, proceed to cart or update UI accordingly
      window.location.href = '/cart';
  }
    */

  async function updateCartCount() {
    try {
      const res = await fetch("/cart.json");
      const cart = await res.json();
      document.querySelectorAll(".cart-count__count").forEach((el) => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      console.error("Error fetching cart:", error);
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Assuming globalConfig is your configuration array
  const popup = document.getElementById("configurationPopup3d");
  const popupContent = document.getElementById("popupContent");
  const closePopupButton = document.getElementById("closePopup");

  function showPopup() {
    let contentHtml = "";
    globalConfig.forEach((item) => {
      // Check if properties exist and format them
      let propertiesHtml = "";
      if (item.properties) {
        propertiesHtml = '<div class="config-item-properties">';
        for (const key in item.properties) {
          propertiesHtml += `<p><strong>${key}:</strong> ${item.properties[key]}</p>`;
        }
        propertiesHtml += "</div>";
      }

      // Add HTML for the config item
      contentHtml += `<div class="config-item">
                        <img src="${item.variantImage}" class="config-item-image" />
                        <div class="config-item-info">
                          <h4>${item.variantName}</h4>
                          ${propertiesHtml}
                        </div>
                      </div>`;
    });

    popupContent.innerHTML = contentHtml;
    popup.classList.remove("hidden");
  }

  // Event listener for the 'view configuration' button
  document
    .getElementById("viewConfiguration")
    .addEventListener("click", function () {
      showPopup();
    });

  // Close popup event
  closePopupButton.addEventListener("click", function () {
    popup.classList.add("hidden");
  });
});

if (Shopify.currency.active == "JPY") {
  var previus_cart_currency_cookie = getCookie("previus_cart_currency");
  if (previus_cart_currency_cookie != "") {
    document.getElementById("custom_currency").value =
      previus_cart_currency_cookie;
  }
}
